import React from 'react';
import { Container, Body5 } from '@ui';
import { ResultContext, RUNNING_STATUS } from '@/contexts/ResultContext';
import { PlanStepList } from '@features/agentOutput';

function parsePlanSteps(plan) {
  if (!plan) return null;
  try {
    const parsed = typeof plan === 'string' ? JSON.parse(plan) : plan;
    if (Array.isArray(parsed)) return parsed;
    if (Array.isArray(parsed?.plan_steps)) return parsed.plan_steps;
    return null;
  } catch {
    return null;
  }
}

export const AgentExecutedPlan = () => {
  const { runningStatus, plan } = React.useContext(ResultContext);
  const planSteps = React.useMemo(() => parsePlanSteps(plan), [plan]);

  if (runningStatus !== RUNNING_STATUS.COMPLETED || !planSteps) return null;

  return (
    <Container>
      <Body5 bold>Executed Plan:</Body5>
      <Container left={16} top={8}>
        <PlanStepList steps={planSteps} />
      </Container>
    </Container>
  );
};
